/**
 * Builds a Google Tag Manager script URL
 *
 * @param gaId Google Analytics identifier
 * @returns Google Tag Manager script URL
 */
export function buildGtmJsUrl(gaId: string): string {
    return `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
}
